import React, { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { rolesConfig } from "./rolesConfig";

export default function AuthCallback() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const backendUrl = import.meta.env.VITE_BACKEND_URL || "http://localhost:3001";

  useEffect(() => {
    fetch(`${backendUrl}/api/auth/me`, {
      credentials: "include",
    })
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch session");
        return res.json();
      })
      .then((user) => {
        const role = user.role || user.clientRole || "machine_operator";
        const landingRoute = rolesConfig[role]?.landingRoute ?? "/dashboard";
        queryClient.invalidateQueries({ queryKey: [`${backendUrl}/api/auth/me`] });
        navigate(landingRoute, {
          replace: true,
        });
      })
      .catch((err) => {
        console.error("Auth callback verification error:", err);
        navigate("/login?error=auth_failed", {
          replace: true,
        });
      });
  }, [navigate, queryClient, backendUrl]);

  return (
    <div
      style={{
        height: "100svh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "16px",
        fontFamily: "system-ui, sans-serif",
        backgroundColor: "#020617",
        color: "#94a3b8",
      }}
    >
      <Loader2 size={40} className="animate-spin text-blue-500" />
      <p style={{ margin: 0, fontSize: "16px", fontWeight: 600, color: "#f8fafc" }}>
        Finalising login…
      </p>
      <p style={{ margin: 0, fontSize: "13px", color: "#64748b" }}>
        Verifying your Central SSO session
      </p>
    </div>
  );
}
